import React from 'react'

import classNames from 'classnames'

import Clickable from '@web/components/Clickable'
import FollowButton from '@web/components/FollowButton'
import useBlockModal from '@web/hooks/useBlockModal'
import usePageInfo from '@web/hooks/usePageInfo'
import nClicks from '@web/libs/nlog/click/codes'

import ContextMenuTopHome from './ContextMenuTopHome'
import styles from './index.module.scss'

const ActionBar = () => {
  const { pageOwner } = usePageInfo()
  const { openUnBlockModal } = useBlockModal({ user: pageOwner! })

  return (
    <div className={styles.btn_area}>
      <div className={styles.inner}>
        {pageOwner ? (
          <>
            {pageOwner.isBlocked ? (
              <span className={styles.btn_wrapper}>
                <Clickable
                  className={classNames(styles.btn, styles.type_unblock)}
                  onClick={() => openUnBlockModal()}
                  nClickCode={nClicks.gnb.YOURPROFILEUNBLOCK}
                >
                  차단 해제
                </Clickable>
              </span>
            ) : (
              <span className={styles.btn_wrapper}>
                <FollowButton isTopHome user={pageOwner} />
              </span>
            )}
            <div className={styles.btn_manage_wrapper}>
              <ContextMenuTopHome user={pageOwner} />
            </div>
          </>
        ) : null}
      </div>
    </div>
  )
}

export default ActionBar
